/* eslint-disable tree-shaking/no-side-effects-in-initialization */
import {getApolloClient} from './client'
import {ApolloCache} from './cache'

const apolloCache = new ApolloCache()

export {
  apolloCache,
  getApolloClient
}
